import React, { useEffect, useState } from 'react'
import Icons from '../../../assets/icons/index'
import styled from './RequestProductDetail.module.css'
import ProductTable from './ProductTable'
import { useNavigate, useParams } from 'react-router-dom'
import callApi from '../../../services/api/apiClient'
import moment from 'moment'
import ModalProvider from '../../../components/modal/ModalProvider'
import { useToast } from '../../../components/toast/Toast'

const status = "cancelled"
const RequestProductDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate()
    const { showToast } = useToast();

    const [detail, setDetail] = useState(null)
    const [isCancel, setIsCancel] = useState(false)

    useEffect(() => {
        getRequestProductDetail()
    }, [])

    const getRequestProductDetail = () => {
        const params = {
            page_no: 1,
            per_page: 10,
        }

        callApi('transfer/productRequestDetail')
            .withKeyParameter({ id: id })
            .withParam(params)
            .loadingGroup('myrequestDetail')
            .execute()
            .then((res) => {
                setDetail(res)
            })
    }

    const onCancelRequest = () => {
        callApi('transfer/cancelRequest')
            .withKeyParameter({ id: id })
            .execute()
            .then(res => {
                if (res?.status === 'success') {
                    getRequestProductDetail()
                    showToast('Cancel Request is successful!', 'success');
                } else {
                    console.log("ERROR", res?.error)
                    showToast(res?.message ? res?.message : res?.error, 'error');
                }
                setIsCancel(false)
            });
    }

    const onAcceptData = () => {
        return detail?.request_lines?.data?.filter(item => item?.is_accepted === true)
    }

    const onRejectData = () => {
        return detail?.request_lines?.data?.filter(item => item?.is_accepted === false)
    }

    console.log("DOOOOO", onAcceptData(), onRejectData())

    return (
        <div className={styled.list_container}>
            <div className="flex items-center" onClick={() => {
                navigate('/request_product_list')
            }}>
                <img src={Icons.back} alt="" className="w-[24px] h-[24px]" />
                <p className={styled.title}>{detail?.name}</p>
                <div className={`${detail?.status === 'pending' ? styled.pending : detail?.status === 'reviewed' ? styled.reviewed : styled.cancelled}`}>
                    <span>{detail?.status === 'pending' ? "Pending" : detail?.status === 'reviewed' ? 'Reviewed' : 'Cancelled'}</span>
                </div>
            </div>
            <div className={styled.row_container}>
                <div className={styled.label}>From</div>
                <div className='text-center'>:</div>
                <div className={styled.value}>{detail?.from_location?.name}</div>
            </div>
            <div className={styled.row_container}>
                <div className={styled.label}>To</div>
                <div className='text-center'>:</div>
                <div className={styled.value}>{detail?.to_location?.name}</div>
            </div>
            <div className={styled.row_container}>
                <div className={styled.label}>Customer Name</div>
                <div className='text-center'>:</div>
                <div className={styled.value}>{detail?.request_partner?.name}</div>
            </div>
            <div className={styled.row_container}>
                <div className={styled.label}>Date</div>
                <div className='text-center'>:</div>
                <div className={styled.value}>{moment(detail?.request_date).format('DD MMMM YYYY')}</div>
            </div>
            <div className={styled.row_container}>
                <div className={styled.label}>Request Type</div>
                <div className='text-center'>:</div>
                <div className={styled.value}>{detail?.request_type}</div>
            </div>
            {
                detail?.status === 'pending' || detail?.status === 'cancelled' ?
                    <ProductTable status={detail?.status} data={detail?.request_lines?.data} />
                    :
                    <>
                        <div className="mt-[24px]">
                            <p className={styled.second_title}>Accept List
                                <span className="text-red-0 ml-[4px]">*</span>
                            </p>
                            <div className='mt-[-24px]'>
                                <ProductTable status={detail?.status} data={onAcceptData()} />
                            </div>
                        </div>
                        <div className="mt-[24px]">
                            <p className={styled.second_title}>Reject List
                                <span className="text-red-0 ml-[4px]">*</span>
                            </p>
                            <div className='mt-[-24px]'>
                                <ProductTable status={detail?.status} data={onRejectData()} />
                            </div>

                        </div>
                    </>
            }

            {detail?.status === 'pending' &&
                <button className={styled.requestCancelBtn} onClick={() => {
                    setIsCancel(true)
                }}>
                    <p className='text-red-3 text-sm'>Request Cancel</p>
                </button>
            }


            <ModalProvider
                isOpen={isCancel}
                onClose={() => setIsCancel(false)}
                title={'Cancel Product Request'}
                cancelBtn={() => setIsCancel(false)}
                sendBtn={() => onCancelRequest()}
                description={'Are you sure you want to  cancel request product?'} />


        </div>
    )
}
export default RequestProductDetail